import React, { useContext, useEffect, useState } from 'react'
import { formatDate, getSampleCsvHeadings, ROUTES } from '../../../shared/constants'
import { useHistory, useParams } from 'react-router'
import { useAuditQuestions } from '../../../hooks/Others/Audit/useAuditQuestions'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'

export default function ViewAuditQuestion() {
  const { getAllAuditQuestion, loading, paginate } = useAuditQuestions()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { auditQuestions } = useContext(OtherContext)
  //console.log('auditQuestions : ', auditQuestions)
  const history = useHistory()
  const params = useParams()
  const [searchQuery, setSearchQuery] = useState('')
  const filterAuditQuestion = auditQuestions
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllAuditQuestion({
      page: page,
      limit: 10,
      searchQuery,
      auditDate: params.auditDate,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_AUDITQUESTION')
  }, [])

  const handleChange = (event, value) => setPage(value)

  let tableBody = []

  if (!loading && filterAuditQuestion.length > 0) {
    tableBody =
      filterAuditQuestion[0].allQuestions &&
      filterAuditQuestion[0].allQuestions.map((item) => {
        console.log({ item })
        return [{ value: item.auditQuestionCode }, { value: item.question }, { value: item.points }]
      })
  }

  const layoutProps = {
    heading: 'Audit Questions',
    heading2: 'View Audit Question',
    url1: ROUTES.ALL_AUDITQUESTION,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    // filename: 'auditQuestions',
    // headers: pdfCsvData.headings,
    // data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'AUDIT',
    // sheetName: 'auditQuestion',
    tempHeaders: getSampleCsvHeadings(['auditCode', 'auditDate', 'question', 'points']),
  }

  return (
    <CustomTableLayout
      tableHeadings={['Question code', 'Question', 'Points']}
      loading={loading}
      tableBody={tableBody}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
    />
  )
}
